import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Image } from '@namespace/icons2';
import { PlayerWrapper } from '../PlayerWrapper';

import styles from './index.module.css';

const ErrorWrapper = ({ children }) => (
  <Box
    flex="1 0 100%"
    direction="column"
    justify="center"
    align="center"
    className={styles.errorContainer}
  >
    {children}
  </Box>
);

const StreamRestrictedError = ({ errorMessage, t }) => (
  <PlayerWrapper dataRole="event-stream-error">
    <ErrorWrapper>
      <AText breed="BU" size="m" color="line_txt_2" align="center">
        {t(errorMessage)}
      </AText>
    </ErrorWrapper>
  </PlayerWrapper>
);

const StreamNotFoundError = ({ errorMessage, t }) => (
  <PlayerWrapper dataRole="event-stream-error-notFound">
    <ErrorWrapper>
      <Image
        name="general/looking_for"
        className={styles.errorIcon}
        width="90px"
        height="90px"
        alt=""
      />
      <AText breed="BU" size="m" color="line_txt_2">
        {t(errorMessage)}
      </AText>
    </ErrorWrapper>
  </PlayerWrapper>
);

const StreamCustomError = ({ errorMessage, t }) => (
  <PlayerWrapper dataRole="event-stream-error-custom">
    <ErrorWrapper>
      <AText breed="R" size="s" color="line_txt_2">
        {errorMessage != null ? t(errorMessage) : ''}
      </AText>
      <Box justify="center" align="center" top="m">
        <AText breed="BU" size="m" color="line_txt_2">
          {t('sportsbook.events.stream.action')}
        </AText>
      </Box>
    </ErrorWrapper>
  </PlayerWrapper>
);

const StreamCrashError = ({ t }) => (
  <PlayerWrapper>
    <ErrorWrapper>
      <Image
        name="general/video-crash"
        className={styles.errorIcon}
        width="90px"
        height="90px"
        alt=""
      />
      <AText breed="BU" size="m" color="line_txt_2">
        {t('sportsbook.events.stream.crash')}
      </AText>
    </ErrorWrapper>
  </PlayerWrapper>
);

export const StreamError = ({ streamUrl, errorMessage, playerError }) => {
  const { t } = useI18n();

  switch (errorMessage) {
    case 'sportsbook.events.stream.noCountry':
    case 'sportsbook.events.stream.paidStream':
      return <StreamRestrictedError errorMessage={errorMessage} t={t} />;

    case 'sportsbook.events.stream.notFound':
      return <StreamNotFoundError errorMessage={errorMessage} t={t} />;

    default: {
      // error from backend or custom error
      if (errorMessage) {
        return <StreamCustomError errorMessage={errorMessage} t={t} />;
      }

      // failsafe
      if (streamUrl == null || playerError) {
        return <StreamCrashError t={t} />;
      }

      // what happened?
      return <StreamCustomError t={t} />;
    }
  }
};
